export default "__VITE_ASSET__BfKCGMBa__"